// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.0
//   protoc               v3.21.12
// source: database.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { StringValue } from "./google/protobuf/wrappers";

export const protobufPackage = "pnc";

export enum StoryType {
  STORY_ONLY = 0,
  DURING_BATTLE = 1,
  BETWEEN_STAGES = 2,
  INGAME_MAIL = 3,
  BATTLE_EVENT = 4,
  EXPLORATION_TIP = 5,
  PROTOCOL_CARD = 6,
  PROFESSOR_TIP = 7,
  UNRECOGNIZED = -1,
}

export function storyTypeFromJSON(object: any): StoryType {
  switch (object) {
    case 0:
    case "STORY_ONLY":
      return StoryType.STORY_ONLY;
    case 1:
    case "DURING_BATTLE":
      return StoryType.DURING_BATTLE;
    case 2:
    case "BETWEEN_STAGES":
      return StoryType.BETWEEN_STAGES;
    case 3:
    case "INGAME_MAIL":
      return StoryType.INGAME_MAIL;
    case 4:
    case "BATTLE_EVENT":
      return StoryType.BATTLE_EVENT;
    case 5:
    case "EXPLORATION_TIP":
      return StoryType.EXPLORATION_TIP;
    case 6:
    case "PROTOCOL_CARD":
      return StoryType.PROTOCOL_CARD;
    case 7:
    case "PROFESSOR_TIP":
      return StoryType.PROFESSOR_TIP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StoryType.UNRECOGNIZED;
  }
}

export function storyTypeToJSON(object: StoryType): string {
  switch (object) {
    case StoryType.STORY_ONLY:
      return "STORY_ONLY";
    case StoryType.DURING_BATTLE:
      return "DURING_BATTLE";
    case StoryType.BETWEEN_STAGES:
      return "BETWEEN_STAGES";
    case StoryType.INGAME_MAIL:
      return "INGAME_MAIL";
    case StoryType.BATTLE_EVENT:
      return "BATTLE_EVENT";
    case StoryType.EXPLORATION_TIP:
      return "EXPLORATION_TIP";
    case StoryType.PROTOCOL_CARD:
      return "PROTOCOL_CARD";
    case StoryType.PROFESSOR_TIP:
      return "PROFESSOR_TIP";
    case StoryType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum EpisodeCategory {
  EPISODE_CATEGORY_STANDARD = 0,
  EPISODE_CATEGORY_DARK = 1,
  EPISODE_CATEGORY_INFORMATION_FRAGMENT = 2,
  EPISODE_CATEGORY_PERSICARIA_EVENT = 3,
  UNRECOGNIZED = -1,
}

export function episodeCategoryFromJSON(object: any): EpisodeCategory {
  switch (object) {
    case 0:
    case "EPISODE_CATEGORY_STANDARD":
      return EpisodeCategory.EPISODE_CATEGORY_STANDARD;
    case 1:
    case "EPISODE_CATEGORY_DARK":
      return EpisodeCategory.EPISODE_CATEGORY_DARK;
    case 2:
    case "EPISODE_CATEGORY_INFORMATION_FRAGMENT":
      return EpisodeCategory.EPISODE_CATEGORY_INFORMATION_FRAGMENT;
    case 3:
    case "EPISODE_CATEGORY_PERSICARIA_EVENT":
      return EpisodeCategory.EPISODE_CATEGORY_PERSICARIA_EVENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EpisodeCategory.UNRECOGNIZED;
  }
}

export function episodeCategoryToJSON(object: EpisodeCategory): string {
  switch (object) {
    case EpisodeCategory.EPISODE_CATEGORY_STANDARD:
      return "EPISODE_CATEGORY_STANDARD";
    case EpisodeCategory.EPISODE_CATEGORY_DARK:
      return "EPISODE_CATEGORY_DARK";
    case EpisodeCategory.EPISODE_CATEGORY_INFORMATION_FRAGMENT:
      return "EPISODE_CATEGORY_INFORMATION_FRAGMENT";
    case EpisodeCategory.EPISODE_CATEGORY_PERSICARIA_EVENT:
      return "EPISODE_CATEGORY_PERSICARIA_EVENT";
    case EpisodeCategory.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum EpisodeType {
  EPISODE_TYPE_PART = 0,
  EPISODE_TYPE_STAGE = 1,
  UNRECOGNIZED = -1,
}

export function episodeTypeFromJSON(object: any): EpisodeType {
  switch (object) {
    case 0:
    case "EPISODE_TYPE_PART":
      return EpisodeType.EPISODE_TYPE_PART;
    case 1:
    case "EPISODE_TYPE_STAGE":
      return EpisodeType.EPISODE_TYPE_STAGE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return EpisodeType.UNRECOGNIZED;
  }
}

export function episodeTypeToJSON(object: EpisodeType): string {
  switch (object) {
    case EpisodeType.EPISODE_TYPE_PART:
      return "EPISODE_TYPE_PART";
    case EpisodeType.EPISODE_TYPE_STAGE:
      return "EPISODE_TYPE_STAGE";
    case EpisodeType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface PartData {
  type: StoryType;
  /** Points to an external file in avgtxt folder (If relevant for this part type) */
  script: string;
  speaker: string;
  /** Content for any type other than an in-game scene. */
  content: string;
  sprite: string;
  choices: string[];
  correctChoice: number;
}

export interface Episode {
  /** The full name of the episode. Usually something like Chapter 6: Embodiment of Scarlet Devil */
  name: string;
  /** The shortened name for displaying on a mobile device, such as Chapter 6 */
  nameShort?: string | undefined;
  nameMultilang?: string | undefined;
  parts: PartData[];
  description?:
    | string
    | undefined;
  /** Python allows List[Union[str, None]], so wrappers preserve nullability. */
  partNames: string[];
  partDescriptions: string[];
  /** Permanent link to the episode, usually the first file in the episode. Used as a key in the interpreter that points to this episode */
  permalink?:
    | string
    | undefined;
  /** The part number, if there is one. */
  number?:
    | number
    | undefined;
  /** If this episode is during a stage or a dedicated scene. */
  type: EpisodeType;
  category?: EpisodeCategory | undefined;
}

export interface Chapter {
  name: string;
  nameMultilang?: string | undefined;
  nameShort?: string | undefined;
  episodes: Episode[];
  /** The chapter number, if this is a numbered chapter. This is a float, not an integer! */
  num?: number | undefined;
}

export interface StoryDatabase {
  main: Chapter[];
  event: Chapter[];
  side: Chapter[];
  crossover: Chapter[];
}

/** Represents a 2D vector with x and y components. */
export interface Vector2 {
  x: number;
  y: number;
}

export interface AvgCharacter {
  /** Relative URL of the texture, as given by the database. */
  texture: string;
  /** Size of face square. This is not always the same! The values are very close though */
  avgFaceSize: Vector2 | undefined;
  avgFacePos: Vector2 | undefined;
  avgCommPos:
    | Vector2
    | undefined;
  /** Size delta for scaling (Usually 768) */
  sizeDelta: number;
}

export interface StringList {
  values: string[];
}

export interface PNCDatabase {
  story: StoryDatabase | undefined;
  speakers: { [key: number]: StringList };
  characters: { [key: string]: AvgCharacter };
}

export interface PNCDatabase_SpeakersEntry {
  key: number;
  value: StringList | undefined;
}

export interface PNCDatabase_CharactersEntry {
  key: string;
  value: AvgCharacter | undefined;
}

function createBasePartData(): PartData {
  return { type: 0, script: "", speaker: "", content: "", sprite: "", choices: [], correctChoice: 0 };
}

export const PartData: MessageFns<PartData> = {
  encode(message: PartData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.script !== "") {
      writer.uint32(18).string(message.script);
    }
    if (message.speaker !== "") {
      writer.uint32(26).string(message.speaker);
    }
    if (message.content !== "") {
      writer.uint32(34).string(message.content);
    }
    if (message.sprite !== "") {
      writer.uint32(42).string(message.sprite);
    }
    for (const v of message.choices) {
      writer.uint32(50).string(v!);
    }
    if (message.correctChoice !== 0) {
      writer.uint32(56).int32(message.correctChoice);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PartData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePartData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.script = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.speaker = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.content = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.sprite = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.choices.push(reader.string());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.correctChoice = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PartData {
    return {
      type: isSet(object.type) ? storyTypeFromJSON(object.type) : 0,
      script: isSet(object.script) ? globalThis.String(object.script) : "",
      speaker: isSet(object.speaker) ? globalThis.String(object.speaker) : "",
      content: isSet(object.content) ? globalThis.String(object.content) : "",
      sprite: isSet(object.sprite) ? globalThis.String(object.sprite) : "",
      choices: globalThis.Array.isArray(object?.choices) ? object.choices.map((e: any) => globalThis.String(e)) : [],
      correctChoice: isSet(object.correctChoice)
        ? globalThis.Number(object.correctChoice)
        : isSet(object.correct_choice)
        ? globalThis.Number(object.correct_choice)
        : 0,
    };
  },

  toJSON(message: PartData): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = storyTypeToJSON(message.type);
    }
    if (message.script !== "") {
      obj.script = message.script;
    }
    if (message.speaker !== "") {
      obj.speaker = message.speaker;
    }
    if (message.content !== "") {
      obj.content = message.content;
    }
    if (message.sprite !== "") {
      obj.sprite = message.sprite;
    }
    if (message.choices?.length) {
      obj.choices = message.choices;
    }
    if (message.correctChoice !== 0) {
      obj.correctChoice = Math.round(message.correctChoice);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PartData>, I>>(base?: I): PartData {
    return PartData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PartData>, I>>(object: I): PartData {
    const message = createBasePartData();
    message.type = object.type ?? 0;
    message.script = object.script ?? "";
    message.speaker = object.speaker ?? "";
    message.content = object.content ?? "";
    message.sprite = object.sprite ?? "";
    message.choices = object.choices?.map((e) => e) || [];
    message.correctChoice = object.correctChoice ?? 0;
    return message;
  },
};

function createBaseEpisode(): Episode {
  return {
    name: "",
    nameShort: undefined,
    nameMultilang: undefined,
    parts: [],
    description: undefined,
    partNames: [],
    partDescriptions: [],
    permalink: undefined,
    number: undefined,
    type: 0,
    category: undefined,
  };
}

export const Episode: MessageFns<Episode> = {
  encode(message: Episode, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.nameShort !== undefined) {
      writer.uint32(90).string(message.nameShort);
    }
    if (message.nameMultilang !== undefined) {
      writer.uint32(18).string(message.nameMultilang);
    }
    for (const v of message.parts) {
      PartData.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.description !== undefined) {
      writer.uint32(34).string(message.description);
    }
    for (const v of message.partNames) {
      StringValue.encode({ value: v!! }, writer.uint32(42).fork()).join();
    }
    for (const v of message.partDescriptions) {
      StringValue.encode({ value: v!! }, writer.uint32(50).fork()).join();
    }
    if (message.permalink !== undefined) {
      writer.uint32(58).string(message.permalink);
    }
    if (message.number !== undefined) {
      writer.uint32(64).int32(message.number);
    }
    if (message.type !== 0) {
      writer.uint32(72).int32(message.type);
    }
    if (message.category !== undefined) {
      writer.uint32(80).int32(message.category);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Episode {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEpisode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.nameShort = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nameMultilang = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.parts.push(PartData.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.partNames.push(StringValue.decode(reader, reader.uint32()).value);
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.partDescriptions.push(StringValue.decode(reader, reader.uint32()).value);
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.permalink = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.number = reader.int32();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.category = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Episode {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      nameShort: isSet(object.nameShort)
        ? globalThis.String(object.nameShort)
        : isSet(object.name_short)
        ? globalThis.String(object.name_short)
        : undefined,
      nameMultilang: isSet(object.nameMultilang)
        ? globalThis.String(object.nameMultilang)
        : isSet(object.name_multilang)
        ? globalThis.String(object.name_multilang)
        : undefined,
      parts: globalThis.Array.isArray(object?.parts) ? object.parts.map((e: any) => PartData.fromJSON(e)) : [],
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      partNames: globalThis.Array.isArray(object?.partNames)
        ? object.partNames.map((e: any) => String(e))
        : globalThis.Array.isArray(object?.part_names)
        ? object.part_names.map((e: any) => String(e))
        : [],
      partDescriptions: globalThis.Array.isArray(object?.partDescriptions)
        ? object.partDescriptions.map((e: any) => String(e))
        : globalThis.Array.isArray(object?.part_descriptions)
        ? object.part_descriptions.map((e: any) => String(e))
        : [],
      permalink: isSet(object.permalink) ? globalThis.String(object.permalink) : undefined,
      number: isSet(object.number) ? globalThis.Number(object.number) : undefined,
      type: isSet(object.type) ? episodeTypeFromJSON(object.type) : 0,
      category: isSet(object.category) ? episodeCategoryFromJSON(object.category) : undefined,
    };
  },

  toJSON(message: Episode): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.nameShort !== undefined) {
      obj.nameShort = message.nameShort;
    }
    if (message.nameMultilang !== undefined) {
      obj.nameMultilang = message.nameMultilang;
    }
    if (message.parts?.length) {
      obj.parts = message.parts.map((e) => PartData.toJSON(e));
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.partNames?.length) {
      obj.partNames = message.partNames;
    }
    if (message.partDescriptions?.length) {
      obj.partDescriptions = message.partDescriptions;
    }
    if (message.permalink !== undefined) {
      obj.permalink = message.permalink;
    }
    if (message.number !== undefined) {
      obj.number = Math.round(message.number);
    }
    if (message.type !== 0) {
      obj.type = episodeTypeToJSON(message.type);
    }
    if (message.category !== undefined) {
      obj.category = episodeCategoryToJSON(message.category);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Episode>, I>>(base?: I): Episode {
    return Episode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Episode>, I>>(object: I): Episode {
    const message = createBaseEpisode();
    message.name = object.name ?? "";
    message.nameShort = object.nameShort ?? undefined;
    message.nameMultilang = object.nameMultilang ?? undefined;
    message.parts = object.parts?.map((e) => PartData.fromPartial(e)) || [];
    message.description = object.description ?? undefined;
    message.partNames = object.partNames?.map((e) => e) || [];
    message.partDescriptions = object.partDescriptions?.map((e) => e) || [];
    message.permalink = object.permalink ?? undefined;
    message.number = object.number ?? undefined;
    message.type = object.type ?? 0;
    message.category = object.category ?? undefined;
    return message;
  },
};

function createBaseChapter(): Chapter {
  return { name: "", nameMultilang: undefined, nameShort: undefined, episodes: [], num: undefined };
}

export const Chapter: MessageFns<Chapter> = {
  encode(message: Chapter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.nameMultilang !== undefined) {
      writer.uint32(18).string(message.nameMultilang);
    }
    if (message.nameShort !== undefined) {
      writer.uint32(26).string(message.nameShort);
    }
    for (const v of message.episodes) {
      Episode.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.num !== undefined) {
      writer.uint32(45).float(message.num);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Chapter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChapter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nameMultilang = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.nameShort = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.episodes.push(Episode.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.num = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Chapter {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      nameMultilang: isSet(object.nameMultilang)
        ? globalThis.String(object.nameMultilang)
        : isSet(object.name_multilang)
        ? globalThis.String(object.name_multilang)
        : undefined,
      nameShort: isSet(object.nameShort)
        ? globalThis.String(object.nameShort)
        : isSet(object.name_short)
        ? globalThis.String(object.name_short)
        : undefined,
      episodes: globalThis.Array.isArray(object?.episodes) ? object.episodes.map((e: any) => Episode.fromJSON(e)) : [],
      num: isSet(object.num) ? globalThis.Number(object.num) : undefined,
    };
  },

  toJSON(message: Chapter): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.nameMultilang !== undefined) {
      obj.nameMultilang = message.nameMultilang;
    }
    if (message.nameShort !== undefined) {
      obj.nameShort = message.nameShort;
    }
    if (message.episodes?.length) {
      obj.episodes = message.episodes.map((e) => Episode.toJSON(e));
    }
    if (message.num !== undefined) {
      obj.num = message.num;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Chapter>, I>>(base?: I): Chapter {
    return Chapter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Chapter>, I>>(object: I): Chapter {
    const message = createBaseChapter();
    message.name = object.name ?? "";
    message.nameMultilang = object.nameMultilang ?? undefined;
    message.nameShort = object.nameShort ?? undefined;
    message.episodes = object.episodes?.map((e) => Episode.fromPartial(e)) || [];
    message.num = object.num ?? undefined;
    return message;
  },
};

function createBaseStoryDatabase(): StoryDatabase {
  return { main: [], event: [], side: [], crossover: [] };
}

export const StoryDatabase: MessageFns<StoryDatabase> = {
  encode(message: StoryDatabase, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.main) {
      Chapter.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.event) {
      Chapter.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.side) {
      Chapter.encode(v!, writer.uint32(26).fork()).join();
    }
    for (const v of message.crossover) {
      Chapter.encode(v!, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StoryDatabase {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStoryDatabase();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.main.push(Chapter.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.event.push(Chapter.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.side.push(Chapter.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.crossover.push(Chapter.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StoryDatabase {
    return {
      main: globalThis.Array.isArray(object?.main) ? object.main.map((e: any) => Chapter.fromJSON(e)) : [],
      event: globalThis.Array.isArray(object?.event) ? object.event.map((e: any) => Chapter.fromJSON(e)) : [],
      side: globalThis.Array.isArray(object?.side) ? object.side.map((e: any) => Chapter.fromJSON(e)) : [],
      crossover: globalThis.Array.isArray(object?.crossover)
        ? object.crossover.map((e: any) => Chapter.fromJSON(e))
        : [],
    };
  },

  toJSON(message: StoryDatabase): unknown {
    const obj: any = {};
    if (message.main?.length) {
      obj.main = message.main.map((e) => Chapter.toJSON(e));
    }
    if (message.event?.length) {
      obj.event = message.event.map((e) => Chapter.toJSON(e));
    }
    if (message.side?.length) {
      obj.side = message.side.map((e) => Chapter.toJSON(e));
    }
    if (message.crossover?.length) {
      obj.crossover = message.crossover.map((e) => Chapter.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StoryDatabase>, I>>(base?: I): StoryDatabase {
    return StoryDatabase.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StoryDatabase>, I>>(object: I): StoryDatabase {
    const message = createBaseStoryDatabase();
    message.main = object.main?.map((e) => Chapter.fromPartial(e)) || [];
    message.event = object.event?.map((e) => Chapter.fromPartial(e)) || [];
    message.side = object.side?.map((e) => Chapter.fromPartial(e)) || [];
    message.crossover = object.crossover?.map((e) => Chapter.fromPartial(e)) || [];
    return message;
  },
};

function createBaseVector2(): Vector2 {
  return { x: 0, y: 0 };
}

export const Vector2: MessageFns<Vector2> = {
  encode(message: Vector2, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.x !== 0) {
      writer.uint32(13).float(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(21).float(message.y);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Vector2 {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVector2();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.x = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.y = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Vector2 {
    return {
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
    };
  },

  toJSON(message: Vector2): unknown {
    const obj: any = {};
    if (message.x !== 0) {
      obj.x = message.x;
    }
    if (message.y !== 0) {
      obj.y = message.y;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Vector2>, I>>(base?: I): Vector2 {
    return Vector2.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Vector2>, I>>(object: I): Vector2 {
    const message = createBaseVector2();
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    return message;
  },
};

function createBaseAvgCharacter(): AvgCharacter {
  return { texture: "", avgFaceSize: undefined, avgFacePos: undefined, avgCommPos: undefined, sizeDelta: 0 };
}

export const AvgCharacter: MessageFns<AvgCharacter> = {
  encode(message: AvgCharacter, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.texture !== "") {
      writer.uint32(10).string(message.texture);
    }
    if (message.avgFaceSize !== undefined) {
      Vector2.encode(message.avgFaceSize, writer.uint32(18).fork()).join();
    }
    if (message.avgFacePos !== undefined) {
      Vector2.encode(message.avgFacePos, writer.uint32(26).fork()).join();
    }
    if (message.avgCommPos !== undefined) {
      Vector2.encode(message.avgCommPos, writer.uint32(34).fork()).join();
    }
    if (message.sizeDelta !== 0) {
      writer.uint32(45).float(message.sizeDelta);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AvgCharacter {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAvgCharacter();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.texture = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.avgFaceSize = Vector2.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.avgFacePos = Vector2.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.avgCommPos = Vector2.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.sizeDelta = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AvgCharacter {
    return {
      texture: isSet(object.texture) ? globalThis.String(object.texture) : "",
      avgFaceSize: isSet(object.avgFaceSize)
        ? Vector2.fromJSON(object.avgFaceSize)
        : isSet(object.avg_face_size)
        ? Vector2.fromJSON(object.avg_face_size)
        : undefined,
      avgFacePos: isSet(object.avgFacePos)
        ? Vector2.fromJSON(object.avgFacePos)
        : isSet(object.avg_face_pos)
        ? Vector2.fromJSON(object.avg_face_pos)
        : undefined,
      avgCommPos: isSet(object.avgCommPos)
        ? Vector2.fromJSON(object.avgCommPos)
        : isSet(object.avg_comm_pos)
        ? Vector2.fromJSON(object.avg_comm_pos)
        : undefined,
      sizeDelta: isSet(object.sizeDelta)
        ? globalThis.Number(object.sizeDelta)
        : isSet(object.size_delta)
        ? globalThis.Number(object.size_delta)
        : 0,
    };
  },

  toJSON(message: AvgCharacter): unknown {
    const obj: any = {};
    if (message.texture !== "") {
      obj.texture = message.texture;
    }
    if (message.avgFaceSize !== undefined) {
      obj.avgFaceSize = Vector2.toJSON(message.avgFaceSize);
    }
    if (message.avgFacePos !== undefined) {
      obj.avgFacePos = Vector2.toJSON(message.avgFacePos);
    }
    if (message.avgCommPos !== undefined) {
      obj.avgCommPos = Vector2.toJSON(message.avgCommPos);
    }
    if (message.sizeDelta !== 0) {
      obj.sizeDelta = message.sizeDelta;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AvgCharacter>, I>>(base?: I): AvgCharacter {
    return AvgCharacter.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AvgCharacter>, I>>(object: I): AvgCharacter {
    const message = createBaseAvgCharacter();
    message.texture = object.texture ?? "";
    message.avgFaceSize = (object.avgFaceSize !== undefined && object.avgFaceSize !== null)
      ? Vector2.fromPartial(object.avgFaceSize)
      : undefined;
    message.avgFacePos = (object.avgFacePos !== undefined && object.avgFacePos !== null)
      ? Vector2.fromPartial(object.avgFacePos)
      : undefined;
    message.avgCommPos = (object.avgCommPos !== undefined && object.avgCommPos !== null)
      ? Vector2.fromPartial(object.avgCommPos)
      : undefined;
    message.sizeDelta = object.sizeDelta ?? 0;
    return message;
  },
};

function createBaseStringList(): StringList {
  return { values: [] };
}

export const StringList: MessageFns<StringList> = {
  encode(message: StringList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.values) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StringList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStringList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.values.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StringList {
    return {
      values: globalThis.Array.isArray(object?.values) ? object.values.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: StringList): unknown {
    const obj: any = {};
    if (message.values?.length) {
      obj.values = message.values;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StringList>, I>>(base?: I): StringList {
    return StringList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StringList>, I>>(object: I): StringList {
    const message = createBaseStringList();
    message.values = object.values?.map((e) => e) || [];
    return message;
  },
};

function createBasePNCDatabase(): PNCDatabase {
  return { story: undefined, speakers: {}, characters: {} };
}

export const PNCDatabase: MessageFns<PNCDatabase> = {
  encode(message: PNCDatabase, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.story !== undefined) {
      StoryDatabase.encode(message.story, writer.uint32(10).fork()).join();
    }
    globalThis.Object.entries(message.speakers).forEach(([key, value]: [string, StringList]) => {
      PNCDatabase_SpeakersEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    globalThis.Object.entries(message.characters).forEach(([key, value]: [string, AvgCharacter]) => {
      PNCDatabase_CharactersEntry.encode({ key: key as any, value }, writer.uint32(26).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PNCDatabase {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePNCDatabase();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.story = StoryDatabase.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = PNCDatabase_SpeakersEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.speakers[entry2.key] = entry2.value;
          }
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          const entry3 = PNCDatabase_CharactersEntry.decode(reader, reader.uint32());
          if (entry3.value !== undefined) {
            message.characters[entry3.key] = entry3.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PNCDatabase {
    return {
      story: isSet(object.story) ? StoryDatabase.fromJSON(object.story) : undefined,
      speakers: isObject(object.speakers)
        ? (globalThis.Object.entries(object.speakers) as [string, any][]).reduce(
          (acc: { [key: number]: StringList }, [key, value]: [string, any]) => {
            acc[globalThis.Number(key)] = StringList.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
      characters: isObject(object.characters)
        ? (globalThis.Object.entries(object.characters) as [string, any][]).reduce(
          (acc: { [key: string]: AvgCharacter }, [key, value]: [string, any]) => {
            acc[key] = AvgCharacter.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: PNCDatabase): unknown {
    const obj: any = {};
    if (message.story !== undefined) {
      obj.story = StoryDatabase.toJSON(message.story);
    }
    if (message.speakers) {
      const entries = globalThis.Object.entries(message.speakers) as [string, StringList][];
      if (entries.length > 0) {
        obj.speakers = {};
        entries.forEach(([k, v]) => {
          obj.speakers[k] = StringList.toJSON(v);
        });
      }
    }
    if (message.characters) {
      const entries = globalThis.Object.entries(message.characters) as [string, AvgCharacter][];
      if (entries.length > 0) {
        obj.characters = {};
        entries.forEach(([k, v]) => {
          obj.characters[k] = AvgCharacter.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PNCDatabase>, I>>(base?: I): PNCDatabase {
    return PNCDatabase.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PNCDatabase>, I>>(object: I): PNCDatabase {
    const message = createBasePNCDatabase();
    message.story = (object.story !== undefined && object.story !== null)
      ? StoryDatabase.fromPartial(object.story)
      : undefined;
    message.speakers = (globalThis.Object.entries(object.speakers ?? {}) as [string, StringList][]).reduce(
      (acc: { [key: number]: StringList }, [key, value]: [string, StringList]) => {
        if (value !== undefined) {
          acc[globalThis.Number(key)] = StringList.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    message.characters = (globalThis.Object.entries(object.characters ?? {}) as [string, AvgCharacter][]).reduce(
      (acc: { [key: string]: AvgCharacter }, [key, value]: [string, AvgCharacter]) => {
        if (value !== undefined) {
          acc[key] = AvgCharacter.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBasePNCDatabase_SpeakersEntry(): PNCDatabase_SpeakersEntry {
  return { key: 0, value: undefined };
}

export const PNCDatabase_SpeakersEntry: MessageFns<PNCDatabase_SpeakersEntry> = {
  encode(message: PNCDatabase_SpeakersEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== 0) {
      writer.uint32(8).int32(message.key);
    }
    if (message.value !== undefined) {
      StringList.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PNCDatabase_SpeakersEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePNCDatabase_SpeakersEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.key = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StringList.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PNCDatabase_SpeakersEntry {
    return {
      key: isSet(object.key) ? globalThis.Number(object.key) : 0,
      value: isSet(object.value) ? StringList.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: PNCDatabase_SpeakersEntry): unknown {
    const obj: any = {};
    if (message.key !== 0) {
      obj.key = Math.round(message.key);
    }
    if (message.value !== undefined) {
      obj.value = StringList.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PNCDatabase_SpeakersEntry>, I>>(base?: I): PNCDatabase_SpeakersEntry {
    return PNCDatabase_SpeakersEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PNCDatabase_SpeakersEntry>, I>>(object: I): PNCDatabase_SpeakersEntry {
    const message = createBasePNCDatabase_SpeakersEntry();
    message.key = object.key ?? 0;
    message.value = (object.value !== undefined && object.value !== null)
      ? StringList.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBasePNCDatabase_CharactersEntry(): PNCDatabase_CharactersEntry {
  return { key: "", value: undefined };
}

export const PNCDatabase_CharactersEntry: MessageFns<PNCDatabase_CharactersEntry> = {
  encode(message: PNCDatabase_CharactersEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      AvgCharacter.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PNCDatabase_CharactersEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePNCDatabase_CharactersEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = AvgCharacter.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PNCDatabase_CharactersEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? AvgCharacter.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: PNCDatabase_CharactersEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = AvgCharacter.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PNCDatabase_CharactersEntry>, I>>(base?: I): PNCDatabase_CharactersEntry {
    return PNCDatabase_CharactersEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PNCDatabase_CharactersEntry>, I>>(object: I): PNCDatabase_CharactersEntry {
    const message = createBasePNCDatabase_CharactersEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? AvgCharacter.fromPartial(object.value)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
